var _path, _path2, _path3, _ellipse, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconGuten = function SvgIconGuten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.5 18H10v83.5h41.543a41.37 41.37 0 0 1-.277-4.794c0-22.514 18.167-40.766 40.578-40.766 5.55 0 10.838 1.12 15.656 3.145V18Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.059C6.5 8.466 13.434 1.5 21.987 1.5h73.824c8.554 0 15.488 6.966 15.488 15.559v15.559H6.499V17.059Z",
    fill: "#30DF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.059C6.5 8.466 13.434 1.5 21.987 1.5h4.13c8.554 0 15.488 6.966 15.488 15.559v15.559H6.5V17.059Z",
    fill: "#00B871"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.684,
    cy: 96.546,
    rx: 29.816,
    ry: 29.954,
    fill: "#00B871"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.173 88.248a11.738 11.738 0 0 0-8.103-3.208c-5.463.005-10.18 3.768-11.482 8.988a.85.85 0 0 1-.821.648h-4.042a.849.849 0 0 1-.833-1.004c1.526-8.142 8.642-14.3 17.19-14.3 4.686 0 8.942 1.851 12.082 4.866l2.52-2.53c1.066-1.072 2.889-.313 2.889 1.202v9.499c0 .94-.758 1.7-1.693 1.7h-9.455c-1.508 0-2.263-1.831-1.197-2.902l2.945-2.959Zm-23.891 11.53h9.455c1.509 0 2.264 1.832 1.197 2.903l-2.944 2.959a11.736 11.736 0 0 0 8.102 3.208c5.46-.005 10.179-3.765 11.482-8.988a.85.85 0 0 1 .822-.648h4.042c.528 0 .93.482.832 1.004-1.526 8.142-8.641 14.301-17.189 14.301a17.39 17.39 0 0 1-12.083-4.867l-2.52 2.531c-1.066 1.071-2.889.312-2.889-1.203v-9.499c0-.939.758-1.7 1.693-1.7Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 15.964C6.5 8.008 13.016 1.5 20.936 1.5h76.012c7.919 0 14.397 6.508 14.397 14.464v44.984a40.25 40.25 0 0 0-19.501-5.008c-4.588 0-8.997.765-13.11 2.175h-32.99v17.104h11.61a40.68 40.68 0 0 0-3.777 7.893h-7.833v15.825h5.581c.146 2.709.555 5.349 1.202 7.893H20.936c-7.92 0-14.436-6.547-14.436-14.503V15.964Zm31.388 42.15V75.22H14.357V58.115h23.53Zm0 24.998H14.357v9.215c0 3.716 2.88 6.61 6.579 6.61h16.952V83.111Zm65.6-32.89V33.069H45.744v17.153h57.744Zm-65.6 0V33.069H14.357v17.153h23.53ZM14.357 25.176h23.53V9.393H20.937c-3.699 0-6.58 2.855-6.58 6.57v9.213Zm31.387 0h57.744v-9.212c0-3.716-2.842-6.571-6.54-6.571H45.744v15.783Z",
    fill: "#243665"
  })));
};

export default SvgIconGuten;